import { removeTypename } from 'utils/removeTypename'

export default {
  methods: {
    /**
     * Поиск в дереве
     */
    $_searchTree(element, value, keyName = 'index', itemName = 'items') {
      if (element[keyName] === value) {
        return element
      } else if (element[itemName]?.length) {
        var i
        var result = null
        for (i = 0; result === null && i < element[itemName].length; i++) {
          result = this.$_searchTree(element[itemName][i], value, keyName, itemName)
        }
        return result
      }
      return null
    },
    $_compareObjects(obj1, obj2, path = '') {
      const changedKeys = []
      obj1 = obj1 || {}
      obj2 = obj2 || {}

      for (let key in obj1) {
        const newPath = path ? `${path}.${key}` : key

        if (obj1.hasOwnProperty(key)) {
          if (!obj2.hasOwnProperty(key)) {
            changedKeys.push(newPath)
          } else {
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
              changedKeys.push(...this.$_compareObjects(obj1[key], obj2[key], newPath))
            } else {
              if (obj1[key] !== obj2[key]) {
                changedKeys.push(newPath)
              }
            }
          }
        }
      }
      for (let key in obj2) {
        const newPath = path ? `${path}.${key}` : key

        if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
          changedKeys.push(newPath)
        }
      }

      return changedKeys
    },
    $_removeTypename(data) {
      return removeTypename(data)
    },
  }
}
